export default {
  isShown: (state) => state.isShown,
  paymentMethodsList: (state) => state.paymentMethodsList,
};
